import React, { Component } from "react";
import { func, string } from "prop-types";
import Row from "../../../../common/grid/Row.js";
import Col from "../../../../common/grid/Col.js";
import Input from "../../../../common/input/Input.js";

class DatesBlock extends Component {
  static propTypes = {
    start_date: string,
    end_date: string,
    onChange: func
  };

  render() {
    return (
      <Col>
        <h2 className="input-heading">Select start & end dates</h2>

        <Row _gap-16>
          <Input
            name="start_date"
            type="date"
            value={this.props.start_date}
            onChange={this.props.onChange}
            ph="Start Date"
          />
          <Input
            name="end_date"
            type="date"
            value={this.props.end_date}
            onChange={this.props.onChange}
            ph="End Date"
          />
        </Row>
      </Col>
    );
  }
}

export default DatesBlock;



// WEBPACK FOOTER //
// ./src/components/main/projects/_form-blocks/DatesBlock.js